import ModalContentWithMedia from './ModalContentWithMedia';
import ModalContentWithMediaColumn from './ModalContentWithMediaColumn';

export default ModalContentWithMedia;
export { ModalContentWithMediaColumn };
